export const requirePasswordDialogInitialState = {
  isDialogOpen: false,
  password: '',
  isValidPassword: true
}

export type RequirePasswordDialogState = typeof requirePasswordDialogInitialState
